import React, { useState, useEffect } from "react";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link, useHistory } from "react-router-dom";
import { pluck } from "underscore";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Role";
import configuration from "../../config";
import { toast } from "react-toastify";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// List all roles
function View({ location }) {
  const [accessRights, setAccessRights] = useState();
  const [isLoader, setIsLoader] = useState(false);

  const columns = [
    {
      title: "ID",
      field: "id",
      render: (rowData) =>
        accessRights?.edit ? (
          <Link
            className="text-indigo-600 hover:text-indigo-900"
            to={`/role/edit/${rowData.role_id}`}
          >
            {rowData.role_id}
          </Link>
        ) : (
          rowData.role_id
        ),
    },
    { title: "Role", field: "title" },
    { title: "Description", field: "description" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "active"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status}
        </span>
      ),
    },
  ];

  const btnGroups = [
    { id: 1, title: "Add New", type: "addNew", path: "/role/add", key: "add" },
    {
      id: 2,
      title: "Make Active",
      type: "makeActive",
      path: "/role",
      key: "edit",
    },
    {
      id: 3,
      title: "Make Inactive",
      type: "makeInactive",
      path: "/role",
      key: "edit",
    },
    // { id: 4, title: "Archive", type: "archive", path: "/role" },
    { id: 5, title: "Delete", type: "delete", path: "/role", key: "delete" },
  ].filter((btn) => accessRights?.[btn.key]);

  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "ROLE");
      setAccessRights(rightsData);
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    getDatas();
  }, [location.state]);

  function getDatas() {
    setIsLoader(true);
    configuration
      .getAPI({ url: "role/list", params: {} })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if (type === "delete") {
      setShowModal(true);
      return;
    }
    setIsLoader(true);
    const sendData = {
      ids,
      type:
        type === "makeActive"
          ? "active"
          : type === "makeInactive"
          ? "inactive"
          : type,
    };
    configuration
      .postAPI({ url: "role/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record updated successfully"
          );
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleDelete() {
    setShowModal(false);
    setIsLoader(true);
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "role/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          setShowModal(false);
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "role_id");
    setIds(idArr);
  };
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.role} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Roles"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
